import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {
  MCC_REVIEW_STATUS,
} from '../../constants/Lookup';
const initialData = {
  paReviewData: {},
  submissionReviewData: [],
  patientDetailsData: {},
  houseHoldData: {},
  reviewStatusData: [],
  houseHoldDocumentsData: [],
  houseHoldIncomeData: [],
  myCoverageCareStatus: null,
  isLoading: false,
  isSubmissionLoading: false,
  errorMsg: null,
  successMsg: null,
  submissionAllTableData: {},
  archivedData: {},
  isSubmissionTableLoading: false,
  isArchivedSuccessMsg: null,
  
};

const slice = createSlice({
  name: 'myCoverageCare',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchisArchivedStart: (state) => {
      state.isArchivedSuccessMsg = null;
      state.errorMsg = null;
    },
    fetchSubmissionTable: (state) => {
      state.isSubmissionTableLoading = true;
      state.errorMsg = null;
    },
    fetchSubmissionStart: (state) => {
      state.isSubmissionLoading = true;
      state.errorMsg = null;
    },
    getPatientDetails: (state, action) => {
      state.patientDetailsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getHouseholdDetails: (state, action) => {
      state.houseHoldDetailsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getHouseholdData: (state, action) => {
      state.houseHoldData = action.payload.data.houseHoldDetails;
      state.houseHoldDocumentsData = action.payload.data.documentDetails;
      state.houseHoldIncomeData = action.payload.data.houseHoldIncomeDetails;
      state.isLoading = false;
      state.errorMsg = null;
    },
    reviewSummaryDetails: (state, action) => {
      state.PAreviewDetailsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.data;
    },
    submissionTableData: (state, action) => {
      state.myCoverageCareStatus = action.payload.status;
      state.isSubmissionTableLoading = false;
      state.errorMsg = null;
      state.submissionAllTableData = action.payload.data;
    },
    resetSubmissionTableData :(state,action)=>{
      state.submissionAllTableData=[];
      state.myCoverageCareStatus = null;
      state.isSubmissionTableLoading = false;
      state.errorMsg = null;
    },
    getPAreviewData: (state, action) => {
      state.paReviewData = action.payload.data.reviewedResponse;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getSubmissionReviewData: (state, action) => {
      state.submissionReviewData = action.payload.data.reviewedResponse;
      state.isSubmissionLoading = false;
      state.errorMsg = null;
    },
    getArchivedData: (state, action) => {
      state.archivedData = action.payload.data.reviewedResponse;
      state.isSubmissionLoading = false;
      state.errorMsg = null;
      state.isLoading = false;
      state.isArchivedSuccessMsg = action.payload?.data;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetStatus: (state) => {
      state.myCoverageCareStatus = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
      state.isSubmissionLoading = false;
      state.isArchivedSuccessMsg = null;
    },
    resetSubmissionData: (state) => {
      state.submissionReviewData = [];
    },
    resetPatientDetails: (state) => {
      state.patientDetailsData = {};
      state.houseHoldDetailsData = {};
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
    resetHouseholdInformation: (state) => {
      state.houseHoldData = {};
      state.errorMsg = null;
      state.successMsg = null;
      state.isLoading = false;
    },
    fetchStatusDropDownData: (state, action) => {
      state.reviewStatusData = action.payload.MCC_REVIEW_STATUS;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  getPatientDetails,
  getHouseholdDetails,
  getHouseholdData,
  fetchStart,
  fetchSubmissionStart,
  fetchError,
  resetStatus,
  resetSubmissionData,
  reviewSummaryDetails,
  getPAreviewData,
  getSubmissionReviewData,
  resetPatientDetails,
  resetHouseholdInformation,
  fetchStatusDropDownData,
  submissionTableData,
  getArchivedData,
  fetchSubmissionTable,
  fetchisArchivedStart,
  resetSubmissionTableData,
} = slice.actions;


export const fetchLookupMccDetails = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`mcc/get/patientdetails/${accountNumber}`)
      .then((data) => {
        console.log(data, 'outside');
        if (data && data.status && data.status === 200) {
          console.log(data, 'Inside');
          dispatch(getPatientDetails(data.data.patientDetails));
          dispatch(getHouseholdDetails(data.data.houseHoldDetails));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchHouseholdData = (houseHoldId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`mcc/get/householddetails/${houseHoldId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getHouseholdData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchReviewData = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`mcc/get/review/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getPAreviewData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchSubmissionReviewData = (accountNumber , submissionId) => {
  return (dispatch) => {
    dispatch(fetchSubmissionStart());
    httpGet(`mcc/get/submission/review/${accountNumber}/${submissionId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getSubmissionReviewData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchPaReviewSummary = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`mcc/save/review`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(reviewSummaryDetails(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchSubmissionTableData = (details) => {
  return (dispatch) => {
    dispatch(fetchSubmissionTable());
    httpPost(`mcc/get/account/history`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(submissionTableData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchArchivedData = (details) => {
  return (dispatch) => {
    dispatch(fetchisArchivedStart());
    httpPost(`mcc/update/archieved`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getArchivedData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetStatusCode = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const resetPatientDetailsData = () => {
  return (dispatch) => {
    dispatch(resetPatientDetails());
  };
};
export const resetHouseholdData = () => {
  return (dispatch) => {
    dispatch(resetHouseholdInformation());
  };
};
export const resetSubmissionReviewData = () => {
  return (dispatch) => {
    dispatch(resetSubmissionData());
  };
};
export const resetSubmissionTable = () => {
  return (dispatch) => {
    dispatch(resetSubmissionTableData());
  };
};
export const getReviewStatus = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [MCC_REVIEW_STATUS],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchStatusDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
